export var ShareEventTabs;
(function (ShareEventTabs) {
    ShareEventTabs[ShareEventTabs["share_event.tabs.email"] = 0] = "share_event.tabs.email";
    ShareEventTabs[ShareEventTabs["share_event.tabs.chat"] = 1] = "share_event.tabs.chat";
})(ShareEventTabs || (ShareEventTabs = {}));
